<template>
  <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.5462 1.53881C5.3354 0.703461 6.6646 0.70346 7.4538 1.53881L10.6071 4.87651C11.812 6.1519 10.9079 8.25 9.15331 8.25L2.84669 8.25C1.09213 8.25 0.187963 6.1519 1.39289 4.87651L4.5462 1.53881Z" fill="#6B6C7B"/>
  </svg>
</template>
